import { useEffect, useRef } from "react";

export default function EmberCanvas() {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let w, h;
    const DPR = Math.min(window.devicePixelRatio || 1, 2);

    const resize = () => {
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * DPR;
      canvas.height = h * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const N = 70;
    const parts = Array.from({ length: N }, () => spawn(true));

    function spawn(anywhere) {
      return {
        x: Math.random() * (canvas.offsetWidth || 1200),
        y: anywhere ? Math.random() * (canvas.offsetHeight || 800) : (canvas.offsetHeight || 800) + 10,
        r: 0.6 + Math.random() * 2.2,
        vy: 0.15 + Math.random() * 0.55,
        vx: (Math.random() - 0.5) * 0.25,
        life: Math.random(),
        hue: 40 + Math.random() * 12,
      };
    }

    function tick() {
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.y -= p.vy;
        p.x += p.vx + Math.sin(p.y * 0.02) * 0.15;
        p.life += 0.004;
        if (p.y < -10) Object.assign(p, spawn(false));
        const flicker = 0.35 + 0.65 * Math.abs(Math.sin(p.life * 6));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `hsla(${p.hue}, 85%, 60%, ${0.5 * flicker})`;
        ctx.shadowColor = `hsla(${p.hue}, 90%, 55%, 0.8)`;
        ctx.shadowBlur = 8 * flicker;
        ctx.fill();
        ctx.shadowBlur = 0;
      }
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={ref} data-testid="hero-interactive-canvas" className="absolute inset-0 h-full w-full pointer-events-none" aria-hidden="true" />;
}
